import { data } from '../../svg/Search/data';
import { makeIcon } from '../makeIcon';

export const Search = makeIcon(data, 'search', 'Search');

export default Search;
